import { mdiEyeOutline } from "@mdi/js";
import { Icon } from "@iconify/react";
import "../../../assets/styles/admin/opd.scss";
import MainButton from "../../../components/button/mainButton";
import { useHistory } from "react-router-dom";
import {
  Table,
  Button,
  Select,
  Row,
  Col,
  Input,
  DatePicker,
  Menu,
  Dropdown,
  Space,
} from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { getDateMeta } from "@fullcalendar/react";
import { useParams } from "react-router-dom";

interface ParamTypes {
  id: string;
}

const OPDList = () => {
  const history = useHistory();
  const [dataMedical, setDataMedical] = useState<any>([]);
  const { id } = useParams<ParamTypes>();

  const columns = [
    {
      title: "",
      dataIndex: "index",
      colSpan: 1,
      key: 1,
    },
    {
      title: "CN",
      dataIndex: "cn",
      colSpan: 1,
      width: "20%",
      key: 2,
    },
    {
      title: "Subject",
      dataIndex: "topic",
      colSpan: 1,
      width: "45%",
      key: 3,
    },
    {
      title: "Date",
      dataIndex: "date",
      colSpan: 1,
      width: "15%",
      align: "center" as const,
      key: 4,
    },
    {
      title: "Action",
      colSpan: 1,
      width: "20%",
      align: "center" as const,
      key: 5,
      render: (data: any) => (
        <a href={`/opd/list/edit/${data._id}/create-opd?idmember=${id}`}>
          {/* {console.log("data =>>>>", data)} */}
          <Icon
            icon="akar-icons:eye"
            width="1.2rem"
            height="1.2rem"
            style={{ color: "#5BAEA9" }}
          />
        </a>
      ),
    },
  ];
  const getData = async () => {
    axios.get(`/medical-records`).then((res) => {
      const xdata = res?.data?.data;
      setDataMedical(xdata);
    });
  };

  useEffect(() => {
    getData();
    console.log("id", id);
  }, []);

  return (
    <div style={{ padding: "0px 0px" }} className="opd-custom-list">
      <div className="input-search">
        <Input.Search
          bordered={false}
          placeholder="Search for  (Date, Course, Treatment)"
          // disabled={ isDisable?.isSearch ? false : true}
          // onSearch={(e) => {
          //   setDataSearch({ ...dataSearch, search: e})
          // }}
        />
      </div>
      <div style={{ marginTop: "20px" }} className="table-data">
        <Table
          columns={columns}
          dataSource={dataMedical}
          bordered
          scroll={{ x: 100 }}
        />
      </div>
    </div>
  );
};
export default OPDList;
